const ScoreDisplayTypes = {
    NORM5: 'norm5'
};

export default ScoreDisplayTypes;
